export default "__VITE_ASSET__CFvN2I3v__"